/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {

        // Apply offset for product detial review anchors
        var shiftWindow = function() { scrollBy(0, - 90) };
        if (location.hash) shiftWindow();
        window.addEventListener("hashchange", shiftWindow);

        // JavaScript to be fired on all pages, after page specific JS is fired
        var scrollToTop = $('.scroll-up-icon');
        if (scrollToTop) {
            scrollToTop.click(function () {
                $('html,body').animate({scrollTop: 0}, 'slow');
                return false;
            });
        }

        // SlideToggle whole shop page sidebar (below 767px width only)
        function filterShopSidebar(){
            var win_width = $( window ).width(); // Get window width

            if (win_width < 767) {
                $('.shop-mobile-toggle').hide();
                $('#show-shop-sidebar').on('click', function () {
                    $('.shop-mobile-toggle').slideToggle();
                    return;
                });
            }else{
                $('.shop-mobile-toggle').show();
            }
        }

        /*$(window).resize(function () {
            filterShopSidebar(); // Call the function on resize
        });*/

        filterShopSidebar(); // Call the function

        // Function that checks that toDate should not be 30days greater then fromDate
        function datepicked() {
            var fromDate = $('.arrivalDate').datepicker('getDate');
            var toDate = $('.departureDate').datepicker('getDate');
            if (fromDate && toDate) {
                var difference_msec = toDate.getTime() - fromDate.getTime();
                //var difference_days = difference_msec / 86400000;
                //$("#nights").val(Math.ceil(difference_days));
            }
        }

        // Initialize datepicker
        $( ".arrivalDate" ).datepicker({
            numberOfMonths: 1,
            firstDay: 1,
            dateFormat: "dd-mm-yy",
            altFormat: "yy-mm-dd",
            minDate: 0,
            maxDate: '+2Y'
            ,
            onSelect: function(dateStr) {
                var d1 = $(this).datepicker("getDate");
                d1.setDate(d1.getDate() + 0); // change to + 1 if necessary
                var d2 = $(this).datepicker("getDate");
                d2.setDate(d2.getDate() + 29); // change to + 29 if necessary
                $(".departureDate").datepicker("setDate", d1.setDate(d1.getDate() + 1)); // Add +1 day to departuredate
                $(".departureDate").datepicker("option", "minDate", d1);
                $(".departureDate").datepicker("option", "maxDate", d2);
                $('#noSpecific').attr('checked', false);
                datepicked();
                $('.departureDate').datepicker('enable'); // Enable the departure datepicker
            }
        });

        // Initialize datepicker
        $( ".departureDate" ).datepicker({
            numberOfMonths: 1,
            firstDay: 1,
            minDate: 0,
            maxDate: '+2Y',
            dateFormat: "dd-mm-yy",
            altFormat: "yy-mm-dd",
            minDate: 0
            ,
            onSelect: function(dateStr) {
                datepicked();
            }
        });

        // Get current date and add initialize it on page load
        var currentDate = new Date();
        var month = currentDate.getMonth() + 1;
        var divas = currentDate.getDate() + 1;

        var arvSelectedDate  =  currentDate.getDate() + '-' + month + '-' + currentDate.getFullYear();
        //var deptSelectedDate =  divas + '-' + month + '-' + currentDate.getFullYear();

		//extend the javascript Date object
		Date.prototype.addDays = function(days) {
			this.setDate(this.getDate() + parseInt(days));
			return this;
		};

		var nextDate  =  currentDate.addDays(1);
		var nextmonth = nextDate.getMonth() + 1;
		var deptSelectedDate  =  nextDate.getDate() + '-' + nextmonth + '-' + currentDate.getFullYear();

          $('#noSpecific').click(function() {
              var that = $(this);
              if (that.is(":checked")) {
                  jQuery('#departureDate').val(null);
                  jQuery('#arrivalDate').val(null);
              }
          });
		// Set the current date on page load
        //jQuery('#arrivalDate').val(arvSelectedDate);
        //jQuery('#departureDate').val(deptSelectedDate);
        $('#noSpecific').attr('checked', 'checked');
        $('#availability-check').trigger('click');
        //$('.departureDate').datepicker('disable'); // Initially disable the departure datepicker

        var slickTestimonials = $('.slick-testimonials > .slick-slider');
        if (slickTestimonials) {
            slickTestimonials.slick({
                arrows          : true,
                dots            : true,
                prevArrow       : '<span class="slick-prev"></span>',
                nextArrow       : '<span class="slick-next"></span>',
                appendArrows    : '.slick-testimonials  .slider-nav',
                appendDots      : '.slick-testimonials  .slider-nav',
                fade            : true,
                adaptiveHeight  : true
            });
        }

        $('.slick-inner-slider > .image-slider').each(function() {
            $(this).slick({
                arrows          : true,
                dots            : true,
                prevArrow       : '<span class="slick-prev"></span>',
                nextArrow       : '<span class="slick-next"></span>',
                appendArrows    : $(this).next().find('.slider-nav'),
                appendDots      : $(this).next().find('.slider-nav'),
                lazyLoad        : 'progressive',
                adaptiveHeight  : true // This is set to FALSE as its working with lazy load -slider bug (https://github.com/kenwheeler/slick/issues/771)
                //fade            : true,   This is commented as its working with lazy load -slider bug (https://github.com/kenwheeler/slick/issues/1583)
            });
        });

        // Check if page template is redirect-custom.php then apply following css for center div
        if($('body').hasClass('page-template-redirect-custom')){
            $('html').addClass('template-redirect');
        }
        // If user is not logged in then empty the postcode field
        if(!$('body').hasClass('logged-in')){
            $('#billing_postcode,#shipping_postcode').val('');
        }
        // Add chosen class on click of filter item
        $( '.yith-wcan-list li a,.webshop-page .filter-form .group a' ).click(function() {
            $(this).addClass('chosen');
        });
        $(document).on('yith-wcan-ajax-filtered', function() {
            $( '.yith-wcan-list li a' ).click(function() {
                $(this).addClass('chosen');
            });
        });

        // Check if cookie-message div is visible (if visible add custom class on body)
        if ($('.cookie-message').is(':visible')) {
            $('body').addClass('cookie-visible');
        } else {
            $('body').removeClass('cookie-visible');
        }

        function cookieVisible(){
            var cookieBoxHeight = $('.cookie-message').innerHeight();
            var mainNavHeight   = $('.master-navigation').innerHeight();

            if($('.cookie-message').is(':visible')){

                // Only for mobile devices
                if($( window ).width() < 850){
                    $('body').addClass('cookie-visible');
                    //$('.master-navigation').css('top',cookieBoxHeight);
                    $('.content-wrapper').css('margin-top',mainNavHeight+cookieBoxHeight);
                }

            }else{
                $('body').removeClass('cookie-visible');
            }
        }

        cookieVisible();

        $(window).resize(function () {
            cookieVisible();
        });

        // Remove cookie visible class on click on close icon
        $( "#cookie-btn" ).click(function() {
            $('body').removeClass('cookie-visible');
            //$('.master-navigation').css('top',0);
            $('.content-wrapper').css('margin-top',$('.master-navigation').innerHeight());
        });

        // Tooltip Initilization
        $('[data-toggle="tooltip"]').tooltip();

        $( "#popular-sort" ).click(function() {
	    $(this).siblings().removeClass('active-sort');
            $(this).addClass('active-sort');
        });
        $( "#alphabetic-sort" ).click(function() {
	    $(this).siblings().removeClass('active-sort');
            $(this).addClass('active-sort');
        });
        $( "#price-sort" ).click(function() {
            $(this).siblings().removeClass('active-sort');
            $(this).addClass('active-sort');
        });
        $( "#district-sort" ).click(function() {
            $(this).siblings().removeClass('active-sort');
            $(this).addClass('active-sort');
        });

        var _DestMenu = document.getElementById('destination-menu');
        //Seconday Menu
        if(_DestMenu){
        var flkty = new Flickity(_DestMenu, {
                        // options
                        freeScroll: true,
                        contain: true,
                        // disable previous & next buttons and dots
                        prevNextButtons: false,
                        pageDots: false
                });
        }

        // For equal heights
        $('.equalheights').matchHeight();
        $('.cardHeight').matchHeight();

        // Initialize read more js
        $('.content-toggle').readmore({
            speed               : 500,
            collapsedHeight     : 173,
            moreLink            : '<a class="read-more" href="#">'+bego_i18n.read_more_label+' <span class="read-more-icon">&raquo;</span></a>',
            lessLink            : '<a class="read-more" href="#">'+bego_i18n.read_less_label+' <span class="read-more-icon rotate-up">&raquo;</span></a>'
        });

        // Initialize read more js on modal show function
        $('.modal').on('shown.bs.modal', function () {
            $('.content-toggle').readmore({
                speed               : 500,
                collapsedHeight     : 90,
                moreLink            : '<a class="read-more" href="#">'+bego_i18n.read_more_label+' <span class="read-more-icon">&raquo;</span></a>',
                lessLink            : '<a class="read-more" href="#">'+bego_i18n.read_less_label+' <span class="read-more-icon rotate-up">&raquo;</span></a>'
            });
         });

        // Initialize read more on shop sidebar
        $('.filter-form-toggle').readmore({
            speed               : 500,
            collapsedHeight     : 705,
            moreLink            : '<a class="read-more" href="#">'+bego_i18n.more_label+' <span class="read-more-icon">&raquo;</span></a>',
            lessLink            : '<a class="read-more" href="#">'+bego_i18n.less_label+' <span class="read-more-icon rotate-up">&raquo;</span></a>'
        });

         // SlideUp top-ups on close btn click
        $( '.top-usp .close-btn' ).click(function() {
            $( '.top-usp' ).slideUp(1000);
            setTimeout(function(){
                $( 'body' ).removeClass('top-usp-open');
                $( '.master-navigation' ).addClass('navbar-fixed-top');
            }, 1001);
        });

        // SlideDown top-ups on btn click
        $( '#open-top-usp' ).click(function() {
            $( 'body' ).addClass('top-usp-open');
            $( '.master-navigation' ).removeClass('navbar-fixed-top');
            $( '.top-usp' ).slideDown(1000);
        });

        // Scoll to bottom
        $("#scroll-to-bottom").click(function() {
            $('html,body').animate({ scrollTop:$('.popular-destinations').offset().top - 60}, 'slow');
        });

        //Show hide newsletter popup
        jQuery('.newsletter-popup-showhide').on('click', function() {
           jQuery('.newsletter-popup-content').slideToggle();
           jQuery('.pink-arrow').toggleClass('up');
        });
        //Show hide newsletter popup
        jQuery('.close').on('click', function() {
            jQuery('.newsletter-popup-content').slideToggle();
            jQuery('.pink-arrow').toggleClass('up');
        });
        jQuery('.showlogin_modal').attr('data-target', '#loginModal');
        jQuery('.showlogin_modal').attr('data-toggle', 'modal');

        // Change account tabs from URL
        var hash = window.location.hash;
        if(hash){
            $('a[href="'+hash+'"]').tab('show');
        }

        var window_width = $( window ).width(); // Get window width

        if(window_width > 767){ // If mobile device then do not apply scrolltoFixed
            // Fixed sidebar scroll on webshop page
            /*$('#scroll-sidebar').scrollToFixed({
                marginTop: $('.navbar').outerHeight() + 10,
                //limit: $($('footer.content-info')).offset().top
                limit: function() {
                    var limit = $('footer.content-info').offset().top  - $('#scroll-sidebar').outerHeight(true) - 150;
                    return limit;
                },
                postFixed: function() {
                    $('#scroll-sidebar').addClass('left');  // after fix position is applied
                },
                preFixed: function() {
                    $('#scroll-sidebar').removeClass('left');    // before fix position is applied
                }
            });*/

            // Fixed sidebar scroll on destination detail page
            $('#city-map').scrollToFixed({
                marginTop: $('.navbar').outerHeight() + 10,
                //limit: $($('footer.content-info')).offset().top
                limit: function() {
                    var limit = $('.section-divider').offset().top  - $('#city-map').outerHeight(true) - 100;
                    return limit;
                },
                postFixed: function() {
                    $('#city-map').addClass('post-none');  // after fix position is applied
                },
                preFixed: function() {
                    $('#city-map').removeClass('pre-none');    // before fix position is applied
                }
                //dontSetWidth: false
            });

            $('#city-map').next().addClass('pull-left');

        }

        // SlideToggle on shop page filters (below 767px width only)

        function filterToggles(){
            var win_width = $( window ).width(); // Get window width

            if (win_width < 767) {
                $('.yith-woocommerce-ajax-product-filter h2').on('click', function () {
                    $(this).next('.yith-wcan-list').slideToggle();
                    $(this).toggleClass('active');
                    return;
                });
            }else{
                $('.yith-woocommerce-ajax-product-filter h2').on('click', function (e) {
                    e.preventDefault();
                });
            }
        }

        filterToggles(); // Call the function

        //Initalize Typeahead for destinations
        $('.typeahead-destination').typeahead(
        {
            hint: true,
            highlight: true,
            minLength: 0,
            classNames: {
                input: 'Typeahead-input',
                hint: 'Typeahead-hint',
                selectable: 'Typeahead-selectable'
             }
        },
        {
            name: 'destinations',
            limit: 999,
            source: substringMatcher(BEGO_Destinations),
            templates: {
                    suggestion: function(data) {
                            return '<div>'+data+'<i class="go-to-destination-arrow"></i><div class="clearfix"></div></div>';
                    },
                    notFound: function(data) {
                            console.log(data);
                            return '<div class="tt-suggestion">'+bego_i18n.dest_not_found+'</div>';
                    }
            }
        }
        ).bind('typeahead:select', function(ev, suggestion){
                goToDestin();
        });

        $('#search-destin').on('submit', function(ev){
                ev.preventDefault();
                goToDestin();
        });

        $('#search-destin').find('[name=destin-query]').keypress(function (e) {
            if (e.which == 13) {
                $(".tt-suggestion:first-child").trigger('click');
            }
        });

        //Handle destination searchform
        function goToDestin(){

                var selectedDestin = $('#search-destin').find('[name=destin-query]').val();

                if(!selectedDestin){
                        return false;
                }

                $.each(BEGO_Destinations, function(index, item){
                        if(item.destinName === selectedDestin){
                                if(item.destinLink){
                                        window.location.href = item.destinLink;
                                        return false;
                                }
                        }
                });
        }

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

var substringMatcher = function(strs) {
  return function findMatches(q, cb) {
    var matches, substringRegex;

    // an array that will be populated with substring matches
    matches = [];

    // regex used to determine if a string contains the substring `q`
    substrRegex = new RegExp(q, 'i');

    // iterate through the pool of strings and for any string that
    // contains the substring `q`, add it to the `matches` array
    $.each(strs, function(i, str) {
      if (substrRegex.test(str.destinName)) {
        matches.push(str.destinName);
      }
    });

    cb(matches);
  };
};

$('.add_to_cart_button').on('click', function() {

       var this_element = $(this);

       var product_id= $(this).attr('data-product_id');

        $.ajax({
            type    : 'POST',
            dataType: 'json',
            url     : bego_i18n.ajaxurl,
            data: {
                'action'        : 'add_to_cart_popup', //calls wp_ajax_nopriv_ajaxlogin
                'product_id'    : product_id,
                //'product_name'  :product_name
            },
            beforeSend: function () {
                //this_element.next().show();
                this_element.addClass("button loading");
                $('#product-loading-overlay').addClass('product-loading-overlay');
            },
            success: function (data) {
                $('#product-loading-overlay').removeClass('product-loading-overlay');
                $("#addtocart h3.add_to_cart_product_name").html(data.message);
                $('#addtocart').modal('show');
                this_element.removeClass("button loading");
            }
        });

    });

    /*********************************************
     *
     * Close add to cart modal on click of
     * continue shopping
     *
     *********************************************/
    $('#close_cart_modal').on('click', function() {
        $('#addtocart').modal('hide');
    });

    /*
    *   Apply classes based on url structure and also
    *   on click of id apply and remove is_active class
    */
    var current_page_url      = window.location.href;
    var hash = current_page_url.includes("#");
    var question = current_page_url.includes("?");

    if(hash) {
        $( "a.is_active" ).removeClass('is_active');
        $( "a.is_active_hash" ).addClass('is_active');
    }else if(question){
        $( "a.is_active" ).removeClass('is_active');
        $( "a.is_active_que" ).addClass('is_active');
    }else{

    }

    $('a.is_active_hash').on('click', function() {
        $( "a.is_active" ).removeClass('is_active');
        $( "a.is_active_hash" ).addClass('is_active');
    });


    /**
     * Blogger slider
     */
    $(".blogger_slider").each(function() {
        var that = $(this), nav = that.children(".nav"), slider = that.children(".container").children("ul");

        that.attr('data-p', 0);

        var total = Math.ceil(slider.children("li").size() / 4) - 1;

        nav.on('click', click);

        function click() {
            var item = $(this), current = parseInt(that.attr('data-p'));

            if (item.hasClass("nav_right")) {
                if (current + 1 <= total) {
                    that.attr('data-p', current + 1);
                }
            } else {
                if (current - 1 >= 0) {
                    that.attr('data-p', current - 1);
                }
            }

            var perc = parseInt(that.attr('data-p')) * 100,
                px = parseInt(that.attr('data-p')) * 11;
            slider.css({'transform': 'translateX(calc(-' + perc + '% - ' + px + 'px))'});
        }
    });


    if (document.URL.indexOf('hotel-boeken-wendy') > 0) {
        $('a.navbar-brand').attr('href', '/nl/wendy-stedentrips/');
    }
})(jQuery); // Fully reference jQuery after this point.